import React from "react";
import "../mspMembersAccess.scss";
import MemberItem from "./MemberItem";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../constants/app.constants";

const MembersBlock = ({
  data = [],
  rolesData = [],
  isDisable = false,
  isDropdownDisabled = false,
  tooltipText = '',
  setShowAccessLevelModal = () => { },
  onNameClick,
  onMemberClick,
  onRoleItemClick = (member, item) => { },
  onDeleteClick = (id) => { }
}) => {
  const navigate = useNavigate();

  return (
    <table className="w-100 table-wrapper hide-scrollbar radius-8 mspMembersAccessTable" style={{ pointerEvents: isDisable ? "none" : "all" }}>
      <tr className={`py-4px pointer grid-container ${onNameClick && 'pointer'}`} onClick={() => { if (onNameClick) onNameClick() }}>
        <th>
          <span className="ml-3">
            Name
            <img alt="" src="/images/actioncenter/arrowdown.svg" className="ml-2" />
          </span>
        </th>
        <th>
          <span className="ml-3">Access Role</span>
        </th>
        <th></th>
      </tr>
      {
        data?.length == 0 ? <div className="mt-5 f-grey d-flex justify-content-center align-items-center">No members exist</div> :
          <div className="border-parent" style={{ borderRadius: "8px" }}>
            {data?.map((memb) => {
              return (
                <MemberItem
                  key={memb.userId || memb.objId_UserSetting}
                  tooltipText={tooltipText}
                  status={memb.status}
                  showInitials={memb.showInitials}
                  initials={memb.initials}
                  image={memb.ImageURL}
                  userName={memb.userName}
                  fullName={memb.fullName}
                  roleName={memb.roleName}
                  roles={rolesData}
                  selectedRoleId={memb.objId_AccessRole}
                  isAdmin={memb.SO_Admin}
                  isDropdownDisabled={isDropdownDisabled}
                  onItemClick={() => {
                    if (onMemberClick) {
                      onMemberClick();
                    } else {
                      (memb.status === "active" || memb.status === "inactive") && (data?.objId_UserSettings !== memb?.objId_UserSetting
                        ? navigate.replace(`${window.location.pathname}/${memb?.objId_UserSetting}`,
                          {
                            selectedUserId: memb?.userId,
                            isSelectedUserLoggedIn: memb?.IsLoggedInUser,
                          }
                        ) : navigate.replace(ROUTE_PATHS.mspsettingsv2.myProfile));
                    }
                  }}
                  onCreateRoleClick={() => {
                    setShowAccessLevelModal(true);
                  }}
                  onRoleItemClick={(roleItem) => { onRoleItemClick(memb, roleItem); }}
                  onDeleteClick={() => { onDeleteClick(memb.objId_UserSetting); }}
                />
              );
            })}
          </div>
      }
    </table>
  );
};

export default MembersBlock;
